import React from 'react';
import { Search, Plus, X } from 'lucide-react';

interface SpreadsheetControlsProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  filteredCount: number;
  totalCount: number;
  onAddNewRow: () => void;
  activeFilters: { [columnName: string]: string };
  onClearFilter: (columnName: string) => void;
  onClearAllFilters: () => void;
  isSearching: boolean;
}

const SpreadsheetControls: React.FC<SpreadsheetControlsProps> = ({
  searchTerm,
  onSearchChange,
  filteredCount,
  totalCount,
  onAddNewRow,
  activeFilters,
  onClearFilter,
  onClearAllFilters,
  isSearching
}) => {
  const activeFilterCount = Object.keys(activeFilters).length;

  return (
    <div className="bg-white rounded-2xl shadow-xl p-6 mb-6">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div className="relative flex-1 max-w-md">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
            <input
              type="text"
              placeholder="Buscar em todos os campos..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
            />
            {isSearching && (
              <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-xs text-gray-400">
                Buscando...
              </div>
            )}
          </div>
          
          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-600">
              {filteredCount} de {totalCount} registros
            </span>
            <button
              onClick={onAddNewRow}
              className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 shadow-md hover:shadow-lg"
            >
              <Plus size={18} />
              Nova Linha
            </button>
          </div>
        </div>

        {activeFilterCount > 0 && (
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm font-medium text-gray-700">Filtros ativos:</span>
            {Object.entries(activeFilters).map(([columnName, value]) => (
              <div
                key={columnName}
                className="flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm"
              >
                <span className="font-medium">{columnName}:</span>
                <span className="max-w-32 truncate">{value}</span>
                <button
                  onClick={() => onClearFilter(columnName)}
                  className="ml-1 hover:bg-blue-200 rounded-full p-0.5 transition-colors duration-150"
                >
                  <X size={12} />
                </button>
              </div>
            ))}
            <button
              onClick={onClearAllFilters}
              className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 underline transition-colors duration-150"
            >
              Limpar todos
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SpreadsheetControls;